import { render, staticRenderFns } from "./CategoryLock.vue?vue&type=template&id=185af785"
import script from "./CategoryLock.vue?vue&type=script&lang=js"
export * from "./CategoryLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports